import React from 'react';

export default function Input({ required = false, value, onChange, placeholder, label, type = "text",wrong=false }) {
    return (
        <div className='flex flex-col justify-start items-start gap-y-1 w-full'>
            <label className='text-slate-500'>{label}{
                required==true && (
                    <span className='text-red-400'> *</span>
                )}</label>
            <input type={type} required={required} className={` w-full ${wrong?'border-2 border-red-500':'border-[#DDDDDD] border'}  rounded-[4px] h-10 p-1`} placeholder={placeholder} onChange={onChange} value={value} />
        </div>
    )
}